<script>
import adminDashboard from './admin-dashboard.vue'
import userDashboard from './user-dashboard.vue'
import { authComputed } from '@/state/helpers'
export default {
  name: 'dashboard-wrapper',
  computed: {
    ...authComputed,
    dashboard () {
      if (!this.currentUser) return null
      if (this.userRole === 'admin') return userDashboard
      if (this.userRole === 'user') return userDashboard
      return null
    }
  }
}
</script>
<template>
  <component :is="dashboard" />
</template>
